import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import SpinnerOverlay from '../../common/spinner/spinner';
import { AddIcon, CancelIcon } from '../../common/icons';
import { CREATE_INDIVIDUAL_EMAIL, GET_INDIVIDUAL_EMAILS  } from '../../../graphql/contact-gql';
import { notifySuccess } from '../../../services/notification';
import IndividualDigitalAddressDetails, { IndividualEmailHandler } from './individual-digital-address-details';
import Button from '../../common/button';

type IndividualDigitalAddressCreateProps = {
    individualId: number;
    isOpen: boolean;
    toggle: () => void;
}

const IndividualDigitalAddressCreate = (props: IndividualDigitalAddressCreateProps) => {
    const {individualId, isOpen, toggle} = props

    const [createIndividualEmail, {loading}] = useMutation(CREATE_INDIVIDUAL_EMAIL)
    const [validated, setValidated] = useState<boolean>(false)

    const digitalAddressRef = useRef<IndividualEmailHandler>(null)

    const onCreateDigitalAddress = () => {
        setValidated(digitalAddressRef.current && digitalAddressRef.current.validate(true)||false);
        if (digitalAddressRef.current && !digitalAddressRef.current.validate(true)) {
            return
        }
        let digitalAddressInput = digitalAddressRef.current && digitalAddressRef.current.getEmail()
        createIndividualEmail({
            variables: {
                individualId: individualId,
                input: digitalAddressInput
            },
            refetchQueries: [{
                query: GET_INDIVIDUAL_EMAILS,
                variables: { individualId: individualId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        setValidated(!!digitalAddressRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable backdrop="static">
            <ModalHeader toggle={toggle} tag={'h2'}>Add an Individual Email Address</ModalHeader>
            <ModalBody>
                <IndividualDigitalAddressDetails ref={digitalAddressRef} onChange={onChange}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onCreateDigitalAddress} disabled={!validated}><AddIcon/> Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default IndividualDigitalAddressCreate
